import React from 'react'
import { Redirect } from 'react-router'

import { OptimizelyExperiment } from '@optimizely/react-sdk'

import { WithFlowRouterProps } from 'utils/FlowProvider'
import { FlowRoute } from 'utils/FlowProvider/types'
import { WithOptimizelyProps } from 'utils/Optimizely'

import { enhance } from './enhance'
import LaterLandingV1 from './Later/LaterLandingV1'
import LaterLandingV3 from './Later/LaterLandingV3'
import LaterOnboardingWelcome from './LaterOnboarding'
import SpendWelcome from './Spend'

type InnerProps = WithFlowRouterProps & WithOptimizelyProps

export const Welcome: React.SFC<InnerProps> = ({ flow }) => {
  switch (flow.toLowerCase()) {
    case 'later':
      return (
        <OptimizelyExperiment experiment="growth-1455_later_landing">
          {variation =>
            variation === 'v1_landing' ? (
              <LaterLandingV1 />
            ) : variation === 'v3_landing' ? (
              <LaterLandingV3 />
            ) : (
              <Redirect to={`/signup${window.location.search}`} />
            )
          }
        </OptimizelyExperiment>
      )
    case 'lateronboarding':
      return <LaterOnboardingWelcome />
    case 'spend':
      return <SpendWelcome />
    case 'directtomobile':
      return <Redirect to={FlowRoute.DirectToMobileLander} />
    default:
      return <Redirect to={`/signup${window.location.search}`} />
  }
}

export default enhance(Welcome)
